export default __webpack_public_path__ + "static/media/cango.f3f071e5.jpg";